// extracted by mini-css-extract-plugin
export default {"guidance-content":"SectionGuidanceContent_guidance-content__22fjn","accordion":"SectionGuidanceContent_accordion__scGKI","loading":"SectionGuidanceContent_loading__T6o2j"};